import React from 'react'
import { BrowserRouter, Route, Switch, Router, Redirect } from 'react-router-dom'
import { PrivateRoute } from './PrivateRoute'
import history from './history';
import { Main as MainLayout } from './layouts';

import {
    Cadastro as CadastroView,
    CompletarCadastro as CompletarCadastroView,
    ConsultaVagas as ConsultaVagasView,
    CadastrarVagas as CadastrarVagasView,
    GerenciarVagas as GerenciarVagasView,
    DadosEmpresarial as DadosEmpresarialView,
    DadosProfissionais as DadosProfissionaisView,
    DetalhesVaga as DetalhesVagaView,
    DetalhesVagaExterno as DetalhesVagaExternoView,
    EditarVaga as EditarVagaView,
    Inicial as InicialView,
    Login as LoginView,
    MeusDados as MeusDadosView,
    NotFound as NotFoundView,
    ResetarSenha as ResetarSenhaView,
    VerCandidatos as VerCandidatosView
} from './views';


const Routes = () => (
    <BrowserRouter>
        <Router history={history}>
            <Switch>
                <Route
                    exact
                    path="/"
                >
                    <Redirect to="/login" />
                </Route>
                <Route
                    exact
                    path="/login"
                    component={LoginView}
                />
                <Route
                    exact
                    path="/cadastrar"
                    component={CadastroView}
                />
                <Route
                    exact
                    path="/reset-senha/:token?"
                    component={ResetarSenhaView}
                >
                </Route>
                <Route
                    exact
                    path="/detalhes-vaga-externo:id?"
                    component={DetalhesVagaExternoView}
                >
                </Route>
                <Route
                    exact
                    path="/not-found"
                    component={NotFoundView}
                >
                </Route>
                <PrivateRoute
                    exact
                    path="/inicial"
                    layout={MainLayout}
                    titulo='Bem vindo'
                    component={InicialView}
                    permissions={['User', 'Company']}
                />
                <PrivateRoute
                    exact
                    path="/completar-cadastro"
                    layout={MainLayout}
                    titulo='Dados'
                    component={CompletarCadastroView}
                    permissions={['User', 'Company', 'completeUser']}
                />
                <PrivateRoute
                    exact
                    path="/consulta-vagas"
                    layout={MainLayout}
                    titulo='Vagas'
                    component={ConsultaVagasView}
                    permissions={['User']}
                />
                <PrivateRoute
                    exact
                    path="/cadastrar-vagas"
                    layout={MainLayout}
                    titulo='Cadastrar Vagas'
                    component={CadastrarVagasView}
                    permissions={['Company']}
                />
                <PrivateRoute
                    exact
                    path="/detalhes-vaga:id?"
                    layout={MainLayout}
                    titulo='Detalhes da Vaga'
                    component={DetalhesVagaView}
                    permissions={['User']}
                />
                <PrivateRoute
                    exact
                    path="/editar-vaga"
                    layout={MainLayout}
                    titulo='Editar Vaga'
                    component={EditarVagaView}
                    permissions={['Company']}
                />
                <PrivateRoute
                    exact
                    path="/gerenciar-vagas"
                    layout={MainLayout}
                    titulo='Gerenciar Vagas'
                    component={GerenciarVagasView}
                    permissions={['Company']}
                />
                <PrivateRoute
                    exact
                    path="/meus-dados"
                    layout={MainLayout}
                    titulo='Meus Dados'
                    component={MeusDadosView}
                    permissions={['User', 'Company']}
                />
                <PrivateRoute
                    exact
                    path="/dados-profissionais"
                    layout={MainLayout}
                    titulo='Dados Profissionais'
                    component={DadosProfissionaisView}
                    permissions={['User']}
                />
                <PrivateRoute
                    exact
                    path="/ver-candidatos"
                    layout={MainLayout}
                    titulo='Ver Candidatos'
                    component={VerCandidatosView}
                    permissions={['Company']}
                />
                <PrivateRoute
                    exact
                    path="/dados-empresarial"
                    layout={MainLayout}
                    titulo='Dados Empresarial'
                    component={DadosEmpresarialView}
                    permissions={['Company']}
                />
                <Redirect to="/not-found" />
            </Switch>
        </Router>
    </BrowserRouter>
);

export default Routes;